import * as React from 'react';
import { cn } from '../../lib/utils';

const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'bg-surface-raised text-text border border-border rounded-lg shadow-sm',
      className
    )}
    {...props}
  />
));
Card.displayName = 'Card';

/** Шапка карточки: заголовок слева, действия справа. */
const CardHeader = React.forwardRef(({ className, title, icon, actions, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'px-xl py-lg border-b border-border flex items-center justify-between gap-lg',
      className
    )}
    {...props}
  >
    {title ? (
      <h2 className="text-section-title font-semibold text-text-strong flex items-center gap-md">
        {icon && <i className={cn('bi', icon, 'text-primary')} aria-hidden="true" />}
        {title}
      </h2>
    ) : (
      children
    )}
    {actions && <div className="flex items-center gap-md">{actions}</div>}
  </div>
));
CardHeader.displayName = 'CardHeader';

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('p-xl', className)} {...props} />
));
CardContent.displayName = 'CardContent';

export { Card, CardHeader, CardContent };
